import { payloadPublisher } from '@atlassian/ufo';
import AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import { version } from 'react';

import { getReleaseVersion } from '../config';

export function allowlist(key: string) {
  const keyParts = key.split('.');
  if (keyParts[0] === 'platform') {
    const [, , , component, experience] = keyParts;
    // Filtering out a bunch of notification component events that are inaccurate,
    // such as "notification-list-render-individual-notification-with-content"
    // https://hello.atlassian.net/wiki/spaces/AWORK/pages/1534849717/Lightweight+DACI+-+How+to+overcome+UFO+sending+individual+notification+events
    if (['notificationList', 'notificationFullPage'].includes(component)) {
      // Why hardcode event names?
      // Currently, it is not possible to import helpers from '@atlassian/notification-list/ufo-helpers'
      // because AFP af:exports on directory level (which is what is happening in the notification packages)
      // is not supported
      const allowedExperiences = [
        'notification-list-render-notifications-without-content',
        'notification-list-render-notifications-with-content',
      ];
      return allowedExperiences.includes(experience);
    }
  }
  return true;
}

export const initUfo = (analyticsClient: AnalyticsWebClient) => {
  payloadPublisher.setup({
    product: 'uchi',
    app: {
      version: { web: getReleaseVersion() },
      framework: { name: 'react', version },
    },
    region: 'unknown',
    gasv3: analyticsClient,
    allowlist,
  });
};
